// Lib
import React from 'react';

// Components
import Button from '../index';
import Feather from '../../Feather';

import { useStyles } from './FlagButtonStyles';

const FlagButton = ({ active, onClick, className }) => {
  const { classes, cx } = useStyles();

  return (
    <Button
      className={cx(classes.button, className)}
      onClick={onClick}
      color="secondary">
      {active ? (
        <Feather type="filledFlag" />
      ) : (
        <Feather printType="stroke" type="flag" />
      )}
    </Button>
  );
};

export default FlagButton;
